import InlineDateCell from '../components/InlineDateCell';
import InlineStatusCell from '../components/InlineStatusCell';
import InlineTextCell from '../components/InlineTextCell';
import InlineTypeCell from '../components/InlineTypeCell';
import TableActionButtonsCell from '../../../core/components/TableActionButtonsCell';
import { ReclamationType } from '../models';

export const buildReclamationColumns = ({
  intl,
  reclamationType,
  statusOptions,
  typeOptions,
  onSaveDate,
  onSaveStatus,
  onSaveType,
  onSaveField,
  formatPhoneNumber,
  onDelete,
  onEdit,
}) => {
  if (reclamationType === ReclamationType.Rewash) {
    return [
      {
        title: intl.formatMessage({ id: 'date' }),
        keyName: '_issueDate',
        sortBy: true,
        cell: {
          component: InlineDateCell,
          mixIns: { onSaveDate },
        },
      },
      { title: intl.formatMessage({ id: 'operation' }), keyName: 'operation' },
      { title: intl.formatMessage({ id: 'rewashReason' }), keyName: 'rewashReason' },
      {
        title: intl.formatMessage({ id: 'action' }),
        keyName: 'action',
        cell: {
          component: TableActionButtonsCell,
          mixIns: {
            buttons: [
              { icon: 'icon-trash', buttonAction: onDelete },
              { icon: 'icon-edit', buttonAction: onEdit },
            ],
          },
        },
      },
    ];
  }

  return [
    { title: intl.formatMessage({ id: 'claim' }), keyName: 'claim' },
    {
      title: intl.formatMessage({ id: 'date' }),
      keyName: '_issueDate',
      sortBy: true,
      cell: {
        component: InlineDateCell,
        mixIns: { onSaveDate },
      },
    },
    {
      title: intl.formatMessage({ id: 'status' }),
      keyName: '_statusLabel',
      cell: {
        component: InlineStatusCell,
        mixIns: { onSaveStatus, statusOptions },
      },
    },
    {
      title: intl.formatMessage({ id: 'vehicle' }),
      keyName: 'vehicle',
      editable: true,
      customComponent: (row) => row?.vehicle || '-',
    },
    {
      title: intl.formatMessage({ id: 'type' }),
      keyName: '_typeLabel',
      cell: {
        component: InlineTypeCell,
        mixIns: { onSaveType, typeOptions },
      },
    },
    {
      title: intl.formatMessage({ id: 'location' }),
      keyName: 'location',
      sortBy: true,
    },
    {
      title: intl.formatMessage({ id: 'customerName' }),
      keyName: 'customerName',
      editable: true,
      customComponent: (row) => row?.customerName || '-',
    },
    {
      title: intl.formatMessage({ id: 'customerPhoneNumber' }),
      keyName: 'customerPhone',
      editable: true,
      customComponent: (row) =>
        typeof formatPhoneNumber === 'function'
          ? formatPhoneNumber(row?.customerPhone || '')
          : row?.customerPhone || '-',
    },
    {
      title: intl.formatMessage({ id: 'customerEmail' }),
      keyName: 'customerEmail',
      editable: true,
      customComponent: (row) => row?.customerEmail || '-',
    },
    {
      title: intl.formatMessage({ id: 'cost' }),
      keyName: '_costRaw',
      cell: {
        component: InlineTextCell,
        mixIns: {
          field: 'cost',
          rawField: '_costRaw',
          currencyField: '_costCurrency',
          onSave: onSaveField,
          isAmount: true,
        },
      },
    },
  ];
};
